import styled from '@emotion/styled';

import { DrawerHeader, Typography } from '@innovamat/glimmer-components';
import { TestStatusCell } from '../../../test-and-results-table/components';
import { useTestAndResults } from '../../context/test-and-results-provider';

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding-bottom: 1rem;
  min-width: 0;
`;

const Title = styled(Typography.H3)`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

function TestAndResultsDrawerHeader(): JSX.Element {
  const {
    onCloseDrawer,
    isNextDisabled,
    isPreviousDisabled,
    onClickNext,
    onClickPrevious,
  } = useTestAndResults();

  return (
    <DrawerHeader
      customTitle={<TestAndResultsCustomTitle />}
      isNextDisabled={isNextDisabled}
      isPreviousDisabled={isPreviousDisabled}
      onClickNext={onClickNext}
      onClickPrevious={onClickPrevious}
      onCloseDrawer={onCloseDrawer}
    />
  );
}

function TestAndResultsCustomTitle(): JSX.Element {
  const { rowSelected } = useTestAndResults();

  if (!rowSelected) return <></>;

  return (
    <TitleWrapper>
      <Title>{rowSelected.rowName}</Title>
      <TestStatusCell
        key={`status_${rowSelected.classroomTestRoundId}`}
        status={rowSelected.status}
      />
    </TitleWrapper>
  );
}

export { TestAndResultsDrawerHeader };
